module.exports = "/images/Templates 01.jpg";